import * as React from "react";
import { forwardRef } from "react";
const SvgOrderNoteAdded = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm3.5 4.95c0-.11.09-.2.2-.2h4.6c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H9.7a.2.2 0 0 1-.2-.2v-1.1Zm0 3c0-.11.09-.2.2-.2h3.1c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H9.7a.2.2 0 0 1-.2-.2v-1.1Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgOrderNoteAdded);
export { ForwardRef as ReactComponent };
